export default {"src":"/_next/static/media/eBidsIcon.cb9df5ad.svg","height":24,"width":24};